import {USER_URL} from '../utils/constants';

export async function getUserClaims(): Promise<UserClaims | null> {
  try {
    // TODO: Remove after testing
    const fakeLoggedIn = sessionStorage.getItem('fakeLoggedIn');
    if (fakeLoggedIn) {
      const mockedPIN = sessionStorage.getItem('mockedPIN') ?? '';

      console.log('Setting fake user claims!');
      const uc: UserClaims = {
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier': 'Fake User',
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/authenticationmethod': 'Fake',
        'http://schemas.microsoft.com/ws/2008/06/identity/claims/authenticationinstant': '???',
        'http://Sustainsys.se/Saml2/LogoutNameIdentifier': '???',
        'http://Sustainsys.se/Saml2/SessionIndex': '000',
        'urn:oid:1.3.6.1.4.1.2428.90.1.5': mockedPIN,
      };

      return uc;
    }

    if (!USER_URL) {
      throw new Error('USER_URL was undefined');
    }

    const response = await fetch(USER_URL, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    if (!response.ok) {
      return null;
    }
    const claims: UserClaims = await response.json();

    return claims;
  } catch (error) {
    return null;
  }
}

export interface UserClaims {
  'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'?: string;
  'http://schemas.microsoft.com/ws/2008/06/identity/claims/authenticationmethod'?: string;
  'http://schemas.microsoft.com/ws/2008/06/identity/claims/authenticationinstant'?: string;
  'http://Sustainsys.se/Saml2/LogoutNameIdentifier'?: string;
  'http://Sustainsys.se/Saml2/SessionIndex'?: string;
  'urn:oid:1.3.6.1.4.1.2428.90.1.5'?: string; // Personal Identity Number from DAC
  [key: string]: any; // Catch any unknown attribute
}
